import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import upperFirst from 'lodash/upperFirst';
import cx from 'clsx';

import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

import { UserStatus } from 'types/schema-generated-types';
import { ClassroomStatus } from 'types';

const useStyles = makeStyles((theme: Theme) => {
  return {
    statusPill: {
      marginTop: 4,
      border: '1px solid #CACACA',
      borderRadius: 12,
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 4,
      paddingRight: 8,
      width: 'min-content'
    },
    statusText: {
      fontWeight: 500
    },
    activityIcon: {
      height: 12,
      width: 12
    },
    activityIconMedium: {
      height: 16,
      width: 16
    },
    activityIconActive: {
      color: theme.palette.success.main
    },
    activityIconInactive: {
      color: '#4A4A4A'
    },
    activityIconPending: {
      color: theme.palette.warning.main
    }
  };
});

export interface StatusChipProps {
  status: UserStatus | ClassroomStatus;
  className?: string;
  size?: 'small' | 'medium';
}

const StatusChip = ({
  status,
  className,
  size = 'medium'
}: StatusChipProps): React.ReactElement => {
  const classes = useStyles();
  return (
    <div className={cx(classes.statusPill, className)}>
      <FiberManualRecordIcon
        className={cx(
          classes.activityIcon,
          { [classes.activityIcon]: size === 'small' },
          { [classes.activityIconMedium]: size === 'medium' },
          {
            [classes.activityIconActive]:
              status === UserStatus.ACTIVE || status === ClassroomStatus.ACTIVE,
            [classes.activityIconInactive]:
              status === UserStatus.INACTIVE || status === ClassroomStatus.ARCHIVED,
            [classes.activityIconPending]: status === UserStatus.PENDING
          }
        )}
      />
      <Typography variant={size === 'small' ? 'subtitle2' : 'body2'} className={classes.statusText}>
        {upperFirst(status.toLowerCase())}
      </Typography>
    </div>
  );
};

export default StatusChip;
